import { Injectable } from '@angular/core';
declare let $: any;
@Injectable({
  providedIn: 'root',
})
export class NotifyService {
  /**
   * Displays a success notification with the given title and message.
   * The notification is shown with a check-circle icon and fades out automatically after a delay.
   * @param title The title of the notification.
   * @param msg The message to be displayed.
   */
  showSuccess(title: string, msg: string) {
    throw new Error('Method not implemented.');
  }
  /**
   * Displays an error notification with the given title and message.
   * The notification is shown with a times-circle icon and fades out automatically after a delay.
   * @param title The title of the notification.
   * @param msg The message to be displayed.
   */
  showError(title: string, msg: string) {
    throw new Error('Method not implemented.');
  }

  constructor() {}
  /**
   * Displays a success notification with the given message.
   * The notification is shown with a check-circle icon and fades out automatically after a delay.
   * @param msg The message to be displayed.
   */
  notifysuccess(msg: string) {
    // Set the HTML content of the success message with the provided text and an icon
    $('#noteSuccessMsg').html(
      msg +
        '<i class="fas fa-check-circle" style="float: right;margin-top: 3px;"></i>'
    );
    // Show the success notification
    $('#noteSuccessMsg').fadeIn('fast');
    // Hide the notification after a delay
    $('#noteSuccessMsg').delay(2000).fadeOut('slow');
  }
  /**
   * Shows a notification with the given message. The notification is displayed
   * as a warning message.
   * @param msg The message to be displayed.
   */
  notifyalart(msg: string) {
    $('#noteAlartMsg').html(
      msg + '<i class="fas fa-bomb" style="float: right;margin-top: 3px;"></i>'
    );
    // Show the notification
    $('#noteAlartMsg').fadeIn('fast');
    // Hide the notification after a delay
    $('#noteAlartMsg').delay(2000).fadeOut('slow');
  }
  /**
   * Shows a notification with the given message. The notification is displayed
   * as an error message.
   * @param msg The message to be displayed.
   */
  notifyError(msg: string) {
    $('#noteErrorMsg').html(
      msg +
        '<i class="fas fa-exclamation-circle" style="float: right;margin-top: 3px;"></i>'
    );
    // Show the notification
    $('#noteErrorMsg').fadeIn('fast');
    // Hide the notification after a delay
    $('#noteErrorMsg').delay(2000).fadeOut('slow');
  }
}
